import StarIcon from "@mui/icons-material/Star";
import { styled } from "@mui/material/styles";
import { type FC } from "react";

import {
  INSIGHT_CHIP_HEIGHT,
  INSIGHT_CHIP_PADDING,
  INSIGHT_META_TYPOGRAPHY,
} from "~/components/UI/CategoryChip/CategoryChip.styles";

const Root = styled("span")({
  display: "inline-flex",
  verticalAlign: "middle",
  flex: "0 0 auto",
  width: "auto",
  maxWidth: "max-content",
});

const Badge = styled("span")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 4,
  height: INSIGHT_CHIP_HEIGHT,
  minHeight: INSIGHT_CHIP_HEIGHT,
  boxSizing: "border-box",
  ...INSIGHT_META_TYPOGRAPHY,
  fontWeight: 600,
  whiteSpace: "nowrap",
  padding: `0 ${INSIGHT_CHIP_PADDING.labelHorizontal}px`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#FEF3C7",
  color: "#92400E",
  "& svg": {
    fontSize: 12,
    color: "#D97706",
    display: "block",
  },
}));

export const InsightFeaturedChip: FC = () => (
  <Root>
    <Badge>
      <StarIcon />
      Featured
    </Badge>
  </Root>
);
